import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import SimulasiAngsuranService from "services/Setup/LoanOrigination/Financial/SimulasiAngsuranService";
import { notification } from "antd";

export const initialState = {
    loading: false,
    message: "",
    showMessage: false,
    redirect: "",
    result: {},
    statusRespon: 0,
    amortisasi:{},
    infoKredit: {},
};

export const getAmortisasi = createAsyncThunk(
    "SimulasiAngsuran/getAmortisasi",
    async (userInput, { rejectWithValue }) => {
        try {
            const response = await SimulasiAngsuranService.getAmortisasi(userInput);
            if (response.status === 200) {
                if (response && response.data) {
                    return response.data;
                }
            } else {
                console.log("Selain Response 200");
                return rejectWithValue({
                    status: "Error",
                    response: response?.data?.message || "Unexpected response!",
                });
            }
        } catch (error) {
            console.log("error :", error);
            notification.error({
                message: error.response.status,
                description: error.response.statusText,
                duration: 3,
            });
            return rejectWithValue(
                error.response?.data?.message || "Unexpected response!"
            );
        }
    }
);

export const getInfoKredit = createAsyncThunk(
    "SimulasiAngsuran/getInfoKredit",
    async (userInput, { rejectWithValue }) => {
        try {
            const response = await SimulasiAngsuranService.getInfoKredit(userInput);
            if (response.status === 200) {
                if (response && response.data) {
                    return response.data;
                }
            } else {
                console.log("Selain Response 200");
                return rejectWithValue({
                    status: "Error",
                    response: response?.data?.message || "Unexpected response!",
                });
            }
        } catch (error) {
            console.log("error :", error);
            notification.error({
                message: error.response.status,
                description: error.response.statusText,
                duration: 3,
            });
            return rejectWithValue(
                error.response?.data?.message || "Unexpected response!"
            );
        }
    }
);

export const getHitungDariAngsuran = createAsyncThunk(
    "SimulasiAngsuran/getHitungDariAngsuran",
    async (userInput, { rejectWithValue }) => {
        try {
            const response = await SimulasiAngsuranService.getHitungDariAngsuran(userInput);
            if (response.status === 200) {
                if (response && response.data) {
                    return response.data;
                }
            } else {
                console.log("Selain Response 200");
                return rejectWithValue({
                    status: "Error",
                    response: response?.data?.message || "Unexpected response!",
                });
            }
        } catch (error) {
            console.log("error :", error);
            notification.error({
                message: error.response.status,
                description: error.response.statusText,
                duration: 3,
            });
            return rejectWithValue(
                error.response?.data?.message || "Unexpected response!"
            );
        }
    }
);

export const SimulasiAngsuranSlice = createSlice({
    name: "SimulasiAngsuran",
    initialState,
    reducers: {
        showNotification: (state, action) => {
            state.message = action.payload;
            state.showMessage = true;
            state.loading = false;
        },
        hideNotification: (state, action) => {
            state.message = "";
            state.showMessage = false;
        },
        showLoading: (state, action) => {
            state.loading = true;
        },
        resetStatusRespon: (state, action) => {
            state.statusRespon = "";
        }
    }, extraReducers: (builder) => {
        builder
            // get amortisasi
            .addCase(getAmortisasi.rejected, (state, action) => {
                state.loading = false;
                state.result = action.payload;
                state.showMessage = true;
            })
            .addCase(getAmortisasi.fulfilled, (state, action) => {
                state.loading = false;
                state.amortisasi = action?.payload;
            })
            .addCase(getAmortisasi.pending, (state) => {
                state.loading = true;
            })
            // get info kredit
            .addCase(getInfoKredit.rejected, (state, action) => {
                state.loading = false;
                state.result = action.payload;
                state.showMessage = true;
            })
            .addCase(getInfoKredit.fulfilled, (state, action) => {
                state.loading = false;
                state.infoKredit = action?.payload;
            })
            .addCase(getInfoKredit.pending, (state) => {
                state.loading = true;
            })
            // get hitung dari angsuran
            .addCase(getHitungDariAngsuran.rejected, (state, action) => {
                state.loading = false;
                state.result = action.payload;
                state.showMessage = true;
            })
            .addCase(getHitungDariAngsuran.fulfilled, (state, action) => {
                state.loading = false;
                state.infoKredit = action?.payload;
            })
            .addCase(getHitungDariAngsuran.pending, (state) => {
                state.loading = true;
            });
    },
});

export const {
    showNotification,
    hideNotification,
    showLoading,
    resetStatusRespon
} = SimulasiAngsuranSlice.actions;

export default SimulasiAngsuranSlice.reducer;